import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { HttpService } from "../../components/services/HttpService";
import { DynamicFormConstants } from "../types/DynamicFormConstants";
import { DynamicFormActions } from "../actions/DynamicFormAction";
import { BackDropActions } from "../actions/BackDropActions";
import { AlertActions } from "../actions/AlertActions";



function* dynamicFormRequest(action) {
  try {
    var payload = action.data;
    console.log(JSON.stringify(payload));
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post,"/master/dynamicform/save",payload);
    if(response && response.status && "SUCCESS" === response.status){
      yield put(AlertActions.success('Dynamic form saved successfully.'));
      yield put(DynamicFormActions.dynamicFormSuccess());
    }else{
      yield put(AlertActions.error(response.result.description));
      yield put(DynamicFormActions.dynamicFormError());
    }
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
    yield put(BackDropActions.end());
  }
}


function* getAllDynamicForm(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.get,"/master/dynamicform");
    if(response && response.status && "SUCCESS" === response.status){
      yield put(DynamicFormActions.getALLDynamicFormSuccess(response.result));
    }else{
      yield put(AlertActions.error(response.result.description));
    }
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
    yield put(BackDropActions.end());
  }
}

function* getActiveDynamicForm(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.get,"/master/dynamicform/active");
    if(response && response.status && "SUCCESS" === response.status){
      yield put(DynamicFormActions.getALLDynamicFormSuccess(response.result));
    }else{
      yield put(AlertActions.error(response.result.description));
    }
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
    yield put(BackDropActions.end());
  }
}

function* getActiveDynamicById(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.get,"/master/dynamicform/"+action.id);
    if(response && response.status && "SUCCESS" === response.status){
      yield put(DynamicFormActions.getDynamicFormByIdSuccess(response.result));
    }else{
      yield put(AlertActions.error(response.result.description));
    }
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
    yield put(BackDropActions.end());
  }
}


function* dynamicFormSaga() {
  yield takeEvery(DynamicFormConstants.DYNAMIC_FORM_REQUEST, dynamicFormRequest);
  yield takeEvery(DynamicFormConstants.GET_ALL_DYNAMIC_FORM_REQUEST, getAllDynamicForm);
  yield takeEvery(DynamicFormConstants.GET_ACTIVE_DYNAMIC_FORM_REQUEST, getActiveDynamicForm);
  yield takeEvery(DynamicFormConstants.GET_DYNAMIC_FORM_BY_ID_REQUEST, getActiveDynamicById);  
}

export default dynamicFormSaga;
